import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>Image Search &copy; {new Date().getFullYear()} All rights reserved.</p>
            <p>Developed with <span>&#x2764;</span> by <a href="/#">ncodes</a></p>
        </footer>
    )
}

export default Footer;
